/**
 * Abstraction around single content being RadioSpot or TVSpot in a bundle.
 *
 * Use as a mixin.
 *
 * Depends on:
 *   - this.content_
 *
 * Exposes:
 *   - this.spot (RadioSpot|TVSpot from a bundle)
 *   - this.bundle (null|TVSpotBundle)
 *   - entries (Array[RadioSpotEntry|TVSpotEntry])
 *
 */

import {flattenArray} from '@/utils';

export function isTaggedContent(spot) {
  if (!spot) {
    return false;
  }

  if (!!spot.tags && spot.tags.length > 0) {
    return true;
  }

  return spot.is_tagged_content;
}

export default {
  computed: {
    /**
     * Return RadioSpot or TVSpotBundle's main_tvspot.
     */
    spot: {
      get() {
        if (this.content_ && this.content_.ctype === 'tv') {
          const bundle = this.content_;
          const mainTVSpot = bundle.tvspots.filter(
            (tvspot) => tvspot.id === bundle.main_tvspot_id
          )[0];
          return mainTVSpot;
        }
        return this.content_;
      },
      set(content) {
        this.content_ = content;
      },
    },
    /**
     * Return TVSpotBundle if available, null otherwise (radio).
     */
    bundle() {
      if (!this.content_ || this.content_.ctype === 'radio') {
        return null;
      }
      return this.content_;
    },
    /**
     * Abstract away spot.entries VS bundle.tvspots.entries VS decoder.entries.
     *
     * If none of those are avaialble, return null. This happens e.g. on
     * the AddDecoderToChannel page, where this mixin is used within the
     * EntryCreationDialog.
     */
    entries() {
      if (this.bundle && this.bundle.tvspots) {
        const bundleEntries = flattenArray(
          this.bundle.tvspots.map((tvspot) => tvspot.entries)
        );
        return bundleEntries;
      }
      if (this.spot) {
        return this.spot.entries;
      } else if (this.decoder) {
        return this.decoder.entries;
      }
      return null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/content.js